import { ATTRIBUTES_VALIDATION_STATE } from 'fe2/Components/UIKit/ClanCreate/Constants'
import { getCurrentClan } from 'helpers/currentAccount'
import { fetchWithSpinner, fetchWrapper as fetch } from 'helpers/fetch'
import { t } from 'helpers/localization'
import get from 'lodash/get'
import has from 'lodash/has'
import * as web2ClientAPI from 'web2ClientAPI/web2ClientAPI'
import { syncAccountInfo, updateAccountInfo } from './ActionAccount'
import { finishCheckAvailabilityRenamingClan } from './ActionClanRename'

export const CHANGE_CLAN_ATTRIBUTES_SUCCESS = 'CHANGE_CLAN_ATTRIBUTES_SUCCESS'
export const START_CLAN_EDIT = 'START_CLAN_EDIT'
export const UPDATE_CLAN_EDIT_STATE = 'UPDATE_CLAN_EDIT_STATE'
export const UPDATE_CLAN_EDIT_ERROR = 'UPDATE_CLAN_EDIT_ERROR'

export const changeClanAttributesSuccessed = (data) => {
  return {
    type: CHANGE_CLAN_ATTRIBUTES_SUCCESS,
    data,
  }
}

export const startClanEdit = (stateBranch) => {
  return {
    type: START_CLAN_EDIT,
    stateBranch,
  }
}

export const updateClanEditState = (stateBranch, data) => {
  return {
    type: UPDATE_CLAN_EDIT_STATE,
    stateBranch,
    data,
  }
}

export const updateClanEditError = (stateBranch, data) => {
  return {
    type: UPDATE_CLAN_EDIT_ERROR,
    stateBranch,
    data,
  }
}

const processExcludedFromClanError = (dispatch, root, sendErrorNotification, currentClan) => {
  sendErrorNotification('excluded_from_clan', currentClan)
  fetchWithSpinner(dispatch, dispatch(syncAccountInfo()))
}

export const processError = (dispatch, json, sendErrorNotification, currentClan, root) => {
  const reason = get(json, 'additional_info.reason')
  if (reason === 'insufficient_permissions') {
    const role = get(json, 'additional_info.role', null)
    if (role) {
      dispatch(updateAccountInfo({ role }))
      sendErrorNotification(reason)
    } else {
      processExcludedFromClanError(dispatch, root, sendErrorNotification, currentClan)
    }
  } else if (reason === 'excluded_from_clan') {
    processExcludedFromClanError(dispatch, root, sendErrorNotification, currentClan)
  } else if (reason === 'clan_already_exist') {
    sendErrorNotification(reason)
    // TODO WGCP-3104 add to response reason not_enought_gold
  } else if (json.error === 'NO_GOLD') {
    sendErrorNotification('no_gold')
  } else if (reason === 'rename_in_cooldown') {
    sendErrorNotification(reason)
  } else if (get(json, 'error_code') === 'restriction_error') {
    // TODO WGCP-3104 add to response reason restriction_error or something similar
    sendErrorNotification('restriction_error', json.error)
  } else if (reason === 'err_bad_words') {
    const messages = {
      name: t('Название содержит запрещенные слова.'),
      tag: t('Тег содержит запрещенные слова.'),
    }
    const field = get(json, 'additional_info.field')
    dispatch(finishCheckAvailabilityRenamingClan({
      field: field,
      error: messages[field],
      available: ATTRIBUTES_VALIDATION_STATE.NOT_AVAILABLE,
    }))
  } else {
    sendErrorNotification()
  }
}

export const shouldHideDialogOnError = (json) => {
  return ['insufficient_permissions', 'excluded_from_clan'].includes(get(json, 'additional_info.reason'))
}

export const changeClanAttributes = (data, disableSuccessfulNotification = false) => {
  return (dispatch, getState) => {
    const state = getState()
    const postChangeAttributesUrl = state.urls.changeAttributes
    const clanId = state.currentAccount.clanId

    dispatch(startClanEdit('clanDescription'))
    return fetch(postChangeAttributesUrl, {
      method: 'POST',
      body: data,
    })
      .then((json) => {
        if (json.status === 'error' || json.errors || !!json.error) {
          processError(
            dispatch,
            json,
            web2ClientAPI.sendClanEditDescriptionErrorNotification,
            getCurrentClan(state),
            state.urls.root,
          )
          dispatch(updateClanEditError('clanDescription', json))
          return shouldHideDialogOnError(json)
        }

        if (!disableSuccessfulNotification)
          web2ClientAPI.sendClanEditDescriptionCompleteNotification()

        dispatch(updateClanEditError('clanDescription', null))

        if (has(data, 'description')) {
          data.rawDescription = data.description
          delete data.description
        }
        dispatch(updateClanEditState('clanDescription', null))
        dispatch(changeClanAttributesSuccessed(Object.assign({}, data, { clanId })))
        return true
      }, () => {
        web2ClientAPI.sendClanEditDescriptionErrorNotification()
        dispatch(updateClanEditError('clanDescription', {
          error: t('Произошла ошибка. Повторите попытку позже'),
        }))
        return false
      })
  }
}

export const changeClanColor = (data) => {
  return (dispatch, getState) => {
    const state = getState()
    const postChangeSymbolicsUrl = state.urls.changeSymbolics
    const clanId = state.currentAccount.clanId

    dispatch(startClanEdit('clanColor'))
    return fetch(postChangeSymbolicsUrl, {
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then((json) => {
        if (json.status === 'error' || json.errors || !!json.error) {
          processError(
            dispatch,
            json,
            web2ClientAPI.sendClanEditColorErrorNotification,
            getCurrentClan(state),
            state.urls.root,
          )
          dispatch(updateClanEditError('clanColor', json))
          return shouldHideDialogOnError(json)
        }
        web2ClientAPI.sendClanEditColorCompleteNotification()
        dispatch(updateClanEditError('clanColor', null))
        dispatch(updateClanEditState('clanColor', null))
        dispatch(changeClanAttributesSuccessed(Object.assign({}, data, { clanId })))
        return true
      }, () => {
        web2ClientAPI.sendClanEditColorErrorNotification()
        dispatch(updateClanEditError('clanColor', {
          error: t('Произошла ошибка. Повторите попытку позже'),
          system_error: true,
        }))
        return false
      })
  }
}